module.exports = __webpack_public_path__ + "media/background_1.70938e65.mp4";